import { useEffect, useState } from "react";
import "./MindMappingReportBSecondSection.css";

const QTag = ({ q, a, impacts }) => (
  <div style={{display:'flex',flexWrap:'wrap',gap:'5px 10px',alignItems:'center',background:'#f0f4ff',border:'1px solid #c7d7fa',borderRadius:'6px',padding:'7px 12px',marginBottom:'12px',fontSize:'12px',lineHeight:1.5}}>
    <span style={{background:'#3b5bdb',color:'#fff',fontWeight:700,padding:'2px 8px',borderRadius:4,fontSize:'10px',whiteSpace:'nowrap'}}>📋 FORM QUESTION</span>
    <span style={{color:'#1e3a8a',fontStyle:'italic'}}>"{q}"</span>
    <span style={{color:'#6b7280',fontSize:'11px'}}>→</span>
    <span style={{color:'#047857',fontWeight:700}}>You answered: <strong>{a}</strong></span>
    <span style={{color:'#6b7280',fontSize:'11px'}}>→</span>
    <span style={{color:'#7c3aed',fontSize:'11px'}}>📊 Impacts: {impacts}</span>
  </div>
);

const MindMappingReportBSecondSection = ({ res,toggle }) => {
  const [userCourse, setUserCourse] = useState("BCA");
  const [isMobile, setIsMobile] = useState(window.innerWidth < 767);

  useEffect(() => {
    if (res?.course) setUserCourse(res.course);
  }, [res]);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 767);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Comprehensive Data Mapping from Image 1 and Image 2
  const courseMapping = {
    "B.Tech": {
      strengths: "Strong technical depth, product thinking",
      limitations: "May lack business & sales skills",
      accessibility: "⭐⭐⭐\n⭐⭐ \n Very High",
      perspective: "✅ Positive for tech startups",
      startupTypes: "SaaS, AI, DeepTech, Platforms"
    },
    "B.E": {
      strengths: "Engineering fundamentals, problem-solving",
      limitations: "Similar to B.Tech, less startup exposure",
      accessibility: "⭐⭐⭐\n⭐⭐ \n Very High",
      perspective: "✅ Positive",
      startupTypes: "Engineering, Manufacturing, Tech"
    },
    "B.Sc": {
      strengths: "Analytical & scientific thinking",
      limitations: "Limited business exposure",
      accessibility: "⭐⭐⭐⭐ High",
      perspective: "⚠️ Neutral -> Positive (domain-based)",
      startupTypes: "Biotech, Data, Research-based"
    },
    "BCA": {
      strengths: "Software & application skills",
      limitations: "Limited large-scale architecture exposure",
      accessibility: "⭐⭐⭐⭐ High",
      perspective: "⚠️ Neutral (needs proof)",
      startupTypes: "Apps, SaaS, IT Services"
    },
    "B.Arch": {
      strengths: "Design + planning mindset",
      limitations: "Capital-intensive domain",
      accessibility: "⭐⭐⭐ Medium",
      perspective: "🎯 Niche positive",
      startupTypes: "Architecture tech, PropTech"
    },
    "B.Pharm": {
      strengths: "Healthcare & compliance knowledge",
      limitations: "Highly regulated sector",
      accessibility: "⭐⭐⭐ Medium",
      perspective: "🏆 High (domain-specific)",
      startupTypes: "PharmaTech, HealthTech"
    },
    "B.Nursing": {
      strengths: "Strong patient & healthcare insight",
      limitations: "Limited business training",
      accessibility: "⭐⭐⭐ Medium",
      perspective: "🎯 Niche positive",
      startupTypes: "Health services, CareTech"
    },
    "B.Com": {
      strengths: "Finance, accounting, operations",
      limitations: "Limited tech understanding",
      accessibility: "⭐⭐⭐⭐ High",
      perspective: "✅ Positive for finance startups",
      startupTypes: "FinTech, Accounting, MSME tools"
    },
    "BBA": {
      strengths: "Business strategy & management",
      limitations: "Execution & tech dependency",
      accessibility: "⭐⭐⭐⭐ High",
      perspective: "✅ Positive",
      startupTypes: "Marketplaces, D2C, Services"
    },
    "B.A": {
      strengths: "Communication & humanities insight",
      limitations: "Perceived low technical depth",
      accessibility: "⭐⭐⭐ Medium",
      perspective: "⚠️ Neutral (idea-driven)",
      startupTypes: "Content, Media, Social startups"
    },
    "B.Des": {
      strengths: "UX, product design, creativity",
      limitations: "Needs tech/business partners",
      accessibility: "⭐⭐⭐⭐ High",
      perspective: "🏆 Increasingly valued",
      startupTypes: "DesignTech, D2C, Product UX"
    },
    "BFA": {
      strengths: "Creative & artistic excellence",
      limitations: "Monetization challenges",
      accessibility: "⭐⭐ Low—Medium",
      perspective: "⚠️ Selective",
      startupTypes: "Creative economy, Media"
    },
    "BSW": {
      strengths: "Social impact & community insight",
      limitations: "Revenue scalability challenges",
      accessibility: "⭐⭐⭐ Medium",
      perspective: "🎯 Impact investors",
      startupTypes: "Social enterprises, NGOs"
    },
    "BHM": {
      strengths: "Hospitality & operations",
      limitations: "Highly people & capital intensive",
      accessibility: "⭐⭐⭐ Medium",
      perspective: "🎯 Industry-specific",
      startupTypes: "FoodTech, Hospitality startups"
    }
  };

  const activeData = courseMapping[userCourse] || courseMapping["BCA"];

  return (
    <div className="mind-mapping-report-b-second-container">
      <div className={toggle?"table-adjust":"mind-mapping-report-b-second-final-table"}> 
        {/* Corner Graphics */}
        <span className="mind-mapping-report-b-second-corner mind-mapping-report-b-second-corner-top-left"></span>
        <span className="mind-mapping-report-b-second-corner mind-mapping-report-b-second-corner-top-right"></span>
        <span className="mind-mapping-report-b-second-corner mind-mapping-report-b-second-corner-bottom-left"></span>
        <span className="mind-mapping-report-b-second-corner mind-mapping-report-b-second-corner-bottom-right"></span>

        <div className="mind-mapping-report-b-second-module-title">
           <span className="module-prefix">Module 2:</span> Founder Degree vs Startup & Investor Perspective
        </div>
        <QTag q="What educational degree or course have you completed?" a={userCourse} impacts="Technical credibility, sector accessibility, investor perception, startup type fit, and co-founder needs" />
        <div className="mind-mapping-report-b-second-table-scroll-wrapper">
          <table className="mind-mapping-report-b-second-inner-table">
            <thead>
              <tr>
                <th className="mind-mapping-report-b-second-col-sno">S.NO</th>
                <th>Degree / Course</th>
                <th>Core Strengths</th>
                <th>Limitations / Disadvantages</th>
                <th>Accessibility to Start</th>
                <th>Investor Perspective</th>
                <th>Best-Fit Startup Types</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="mind-mapping-report-b-second-col-sno">2 A</td>
                <td className="mind-mapping-report-b-second-user-val">{userCourse}</td>
                <td>{activeData.strengths}</td>
                <td>{activeData.limitations}</td>
                <td>
                  {isMobile ? (
                    activeData.accessibility.split('\n').map((line, index) => (
                      <span key={index}>
                        {line}
                        {index < activeData.accessibility.split('\n').length - 1 && <br />}
                      </span>
                    ))
                  ) : (
                    activeData.accessibility
                  )}
                </td>
                <td>{activeData.perspective}</td>
                <td className="mind-mapping-report-b-second-highlight">{activeData.startupTypes}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default MindMappingReportBSecondSection;